import { titles, type Title } from '@/mocks/titles';

export interface FilterState {
  genre: string;
  region: string;
  year: string;
  status: string;
  sort: 'default' | 'rating' | 'year' | 'newest';
}

export const defaultFilters: FilterState = {
  genre: '',
  region: '',
  year: '',
  status: '',
  sort: 'default',
};

export function getTitleById(id: string): Title | undefined {
  return titles.find((item) => item.id === id);
}

export function filterTitles(list: Title[], filters: Partial<FilterState>): Title[] {
  const { genre = '', region = '', year = '', status = '', sort = 'default' } = filters;

  const result = list.filter((item) => {
    if (genre && !item.genres.includes(genre)) return false;
    if (region && item.region !== region) return false;
    if (year && item.year !== Number(year)) return false;
    if (status && item.status !== status) return false;
    return true;
  });

  const sorted = [...result];
  if (sort === 'rating') {
    sorted.sort((a, b) => b.rating - a.rating);
  } else if (sort === 'year') {
    sorted.sort((a, b) => b.year - a.year);
  } else if (sort === 'newest') {
    sorted.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
  }
  return sorted;
}

export function searchTitles(list: Title[], keyword: string): Title[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return list.filter(
    (item) =>
      item.title.toLowerCase().includes(kw) ||
      item.director.toLowerCase().includes(kw) ||
      item.cast.some((c) => c.toLowerCase().includes(kw)) ||
      item.genres.some((g) => g.includes(kw)),
  );
}

export function getRelated(title: Title, limit = 6): Title[] {
  const scored = titles
    .filter((item) => item.id !== title.id)
    .map((item) => {
      let score = 0;
      if (item.type === title.type) score += 2;
      score += item.genres.filter((g) => title.genres.includes(g)).length * 3;
      if (item.region === title.region) score += 1;
      score += item.rating;
      return { item, score };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((entry) => entry.item);
}

export function paginate<T>(list: T[], page: number, pageSize: number): T[] {
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

export function mergeList(list: Title[], page: number, pageSize: number, mode: 'page' | 'more'): Title[] {
  if (mode === 'more') {
    return list.slice(0, page * pageSize);
  }
  return paginate(list, page, pageSize);
}